import { render, staticRenderFns } from "./ed-subject-calendar.component.vue?vue&type=template&id=6cfd3780&scoped=true&"
import script from "./ed-subject-calendar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-calendar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-calendar.component.scss?vue&type=style&index=0&id=6cfd3780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd3780",
  null
  
)

export default component.exports